import React from "react";
import { useNavigate } from "react-router-dom";

const shapes = {
  round: "rounded-[24px]",
  circle: "rounded-[50%]",
} as const;
const variants = {
  fill: {
    indigo_A700: "bg-indigo-a700 text-white-a700",
    gray_100: "bg-gray-100 shadow-sm",
    gradient: "bg-newLPButtonGradient text-[white]"
  },
} as const;
const sizes = {
  sm: "h-[48px] px-2.5",
  md: "h-[50px] px-[26px] text-[16px]",
  xs: "h-[28px] px-1",
} as const;

type ButtonProps = Omit<
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  "onClick"
> &
  Partial<{
    className: string;
    leftIcon: React.ReactNode;
    rightIcon: React.ReactNode;
    onClick: () => void;
    shape: keyof typeof shapes;
    variant: keyof typeof variants | null;
    size: keyof typeof sizes;
    color: string;
  }>;
const Button: React.FC<React.PropsWithChildren<ButtonProps>> = ({
  children,
  className = "",
  leftIcon,
  rightIcon,
  shape,
  variant = "fill",
  size = "xs",
  color = "gray_100",
  ...restProps
}) => {
  const navigate = useNavigate();
  return (
    <button
      className={`${className} flex flex-row items-center justify-center sm:px-5 text-center cursor-pointer whitespace-nowrap text-white-a700 text-[16px] font-semibold bg-indigo-a700 min-w-[158px] rounded-[24px] ${shape && shapes[shape]} ${size && sizes[size]} ${variant && variants[variant]?.[color as keyof (typeof variants)[typeof variant]]}`}
      {...restProps}
      type="button"
      // onClick={() => navigate("/onboarding")} // a static navigation is added here
    >
      {!!leftIcon && leftIcon}
      {children}
      {!!rightIcon && rightIcon}
    </button>
  );
};

export { Button };
